import { useContext, useState } from "react";
import "./styles.css";
import SideMenuAdmin from "../SideMenuAdmin/SideMenuAdmin";
import { IoMenu } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Context } from "../../hooks/useAuthContext";
import { Button } from "reactstrap";
import ManutencaoModal from "./components/ManutencaoModal";
import ComunicadoFormModal from "./components/ComunicadoFormModal";

function HeaderAdmin() {
  const { userData } = useContext(Context);
  const [menuAberto, setMenuAberto] = useState(false);
  const [manutencaoModalOpen, setManutencaoModalOpen] = useState(false);
  const [comunicadoModalOpen, setComunicadoModalOpen] = useState(false);

  const toggleManutencaoModal = () =>
    setManutencaoModalOpen(!manutencaoModalOpen);

  const toggleComunicadoModal = () =>
    setComunicadoModalOpen(!comunicadoModalOpen);

  return (
    <div className="headerAdmin">
      <div className="headerItemsAdmin">
        <Link to={"/"} style={{ textDecoration: "none" }}>
          <div className="logoAdmin">
            <img
              src="https://i.imgur.com/nCIToeZ.png"
              alt="logo da link do bem"
            />
          </div>
        </Link>

        <div className="menuIcon">
          {userData.tipoConta === "administrador" && (
            <Button outline color="danger" onClick={toggleManutencaoModal}>
              Manutenção
            </Button>
          )}

          {/* {userData.tipoConta === "administrador" && (
            <Button style={{  marginLeft: 8 }} outline color="warning" onClick={toggleComunicadoModal}>
              Comunicado
            </Button>
          )} */}

          <IoMenu
            style={{ fontSize: 35, marginLeft: 20, cursor: "pointer" }}
            onClick={() => setMenuAberto(true)}
          />
        </div>
      </div>

      <SideMenuAdmin isOpen={menuAberto} onClose={() => setMenuAberto(false)} />

      <ManutencaoModal
        isOpen={manutencaoModalOpen}
        toggle={toggleManutencaoModal}
      />

      <ComunicadoFormModal
        isOpen={comunicadoModalOpen}
        toggle={toggleComunicadoModal}
      />
    </div>
  );
}

export default HeaderAdmin;
